import { LOAD_DEVICE_DETAILS } from '../constants/commonEvents'
angular
  .module('surfsightApp.controllers')
  .controller('RecordingTimelineController', [
    '$rootScope',
    '$scope',
    '$localStorage',
    '$state',
    'edgeFactoryV2',
    '$translate',
    function (
      $rootScope,
      $scope,
      $localStorage,
      $state,
      edgeFactoryV2,
      $translate1
    ) {
      const translationsSrc = () => {
        return `./locale/lytx-recording-video/${$translate1.use()}.json`
      }
      const imei = $scope.deviceId
      let edge = edgeFactoryV2.findItemByImei(imei)
      edge = edge.item
      $scope.lytxTimelineRecordingProperties = {
        authToken: $localStorage.userToken,
        amplitudeKey: AMPLITUDE_KEY,
        organizationId: $localStorage.currentUserOrganization.id,
        imei: edge && edge.imei,
        title: edge && edge.name,
        translationsSrc: translationsSrc(),
        isDownloadRequested: false,
        eventConfigSrc:
          './custom-component-configuration/lytx-recording-video/events.json',
        isBlurringEnabled: edge ? !!edge.isBlurringEnabled : false
      }
      if (!edge) {
        $scope.$emit(LOAD_DEVICE_DETAILS.REQUEST, { imei })
        const canceller = $scope.$on(LOAD_DEVICE_DETAILS.RESPONSE, function (
          e,
          data
        ) {
          if (data.imei === imei) {
            edge = edgeFactoryV2.findItemByImei(imei)
            edge = edge.item
            $scope.lytxTimelineRecordingProperties = {
              ...$scope.lytxTimelineRecordingProperties,
              imei: edge.imei,
              title: edge.name
            }
            canceller()
          }
        })
      }
      $scope.$on('$downloadRecordingRequested', function () {
        $scope.lytxTimelineRecordingProperties.isDownloadRequested = true
      })
      $rootScope.$on('$translateChangeSuccess', function () {
        $scope.lytxTimelineRecordingProperties.translationsSrc = translationsSrc()
      })
      $scope.switchToFileView = () => {
        $state.go('home.common.recordings.list', { imei })
      }
    }
  ])
